/*
 shipping_price Options
 
 0 = Free Shipping
 1 = Express Envelope
 2 = Express 500g Parcel
 3 = Auspost Express 3kg
 4 = NULL
 5 = Auspost Express 5kg

Tube Weight:      	
 Topo 	   = 50g
 Topo L    = 120g
 Chart     = 90g
 Chart L   = 200g
 BAChart   = 120g
 BAChart L = 250g

*/          
var shipOp = 0;
var weight_options = new Array(0,300,2700,4700,5700,7500,9500,9999999999999);
var freight_charge_new = new Array(0,24,32,40,64,72,80,160)

var shipping_price = new Array([0],[1],[2],[3],[5],[3,3],[3,5],[5,5],[3,5,5],[5,5,5],[3,5,5,5],[5,5,5,5])
var freight_charge = new Array(0,12,24,32,0,40);
var shipper = '';
var shippingDay = 3
var pdfOnly = true;
  
if (isEnc == true){
  var encCorrect = false;
} else {
  var encCorrect = true;
};

updatecart = function(control){
  
  $('#recycle').hide()
  // Turn off Checkout Button
  $('#checkoutButton').attr("disabled", "disabled");
  //console.log($('#checkoutButton').attr("disabled"));
  // Update descrtiption
  $('#ShippingTotal').html('Calculating Postage & Handling...');
  
  var tubeWg = 0;
  var satchelWg = 0;
  var tubeCnt = 0;
  var satchelCnt = 0;
  pdfOnly = true; 
  
  for (m in metadata){ // Loop through all Items in Cart?
    
    //console.log(metadata[m]);
    
    var product = metadata[m][0].sku.split("-").slice(-1)[0].toLowerCase();
    var pvendor = metadata[m][0].vendor;
    var weight = parseInt(metadata[m][1][product]);    
    if (pvendor == 'bh'){
    	weight = metadata[m][1].Each;
    };
    var packing = metadata[m][2].packing;
    
    if (metadata[m][0].sku.toLowerCase().includes('canvas')){
      packing = 'tube';    
      vt = metadata[m][0].variant_title;
      weight = metadata[m][1][vt];
    }
    
    
    weight = metadata[m][0].grams;      
    
    
    //console.log(weight);
    //console.log(packing);
    
    
    // Shipping Days Description    
    
    if (pvendor == 'ga' || pvendor == 'hema'){
      if (shippingDay < 7){
        shippingDay = 7;
      };
    }
    if (pvendor == 'tasmap'){
      if (shippingDay < 10){
        shippingDay = 10;
      };
    }

    if (product != 'pdf download'){
      pdfOnly = false;
    };    
    
    // 
    if (isNaN(weight)){
    	weight = 0;
	};
        
    var qty = $(document.getElementById('Updates_'+metadata[m][3])).val();
    weight *= qty;
    
    if (packing=='tube'){      
      tubeWg += weight;       
      tubeCnt++;
    };
    
    if (packing=='satchel'){
      if (product == 'laminated'){ // If folded_map is laminated, gets placed in Tube.
        tubeWg += weight; 
      	tubeCnt++;
      } else {
      	satchelWg += weight; 
      	satchelCnt++;
      };
    }; 
  };
  
  if (pdfOnly == true){
    shippingDayStr = "30 minutes";
    $('#checkoutButton').removeAttr("disabled");    
  } else {
    shippingDayStr = shippingDay + " working days";
  };
  
  /*
  if (tubeWg != 0) { 
    if (tubeCnt > 4){ // Too many items for a small diameter tube
      tubeWg = tubeWg + 500;
    } else {
      tubeWg = tubeWg + 200;       
    };      
  };
  
  if (satchelWg >= 400) { // Too heavy / big for a 500g express envelope
    satchelWg = satchelWg + 200;
  };
  */
  
  var shipping_weight = tubeWg + satchelWg;
  
  if (shipping_weight > 0) {
    //console.log(shipping_weight);
    var spare_weight;
    var this_weight;
    
    for (shipOp=0; shipOp < weight_options.length; shipOp++) {
      if (weight_options[shipOp] >= shipping_weight){
        spare_weight = weight_options[shipOp] - shipping_weight;
        this_weight = weight_options[shipOp];	
        break;
      };
    };    

    /*
    if (tubeWg != 0 && shipOp==1){ // Force to 500g Express for Tubes
      shipOp = 2;
    };      
    */
    
    if (tubeWg > 0){
		//$('#recycle').show()
    };
    
    if (this_weight == 0) {
      shipper = "Free";
    } else {
      shipper = "Auspost";    
    };
  };
  updateShipping(shipping_price[shipOp],control);
};

$('.encfield').on('focusout', function(){      
	var s63UP = $('#S63UserPermit').val()
    var s63Soft = $('#S63Software').val()
    if (s63UP.replace(" ","").length == 28){
      encCorrect = true;  
      $('#checkoutButton').removeAttr("disabled")
    } else {
      $('#checkoutButton').attr("disabled", "disabled");      
    };		
});


updateShipping = function(shipping_price,checkout) {
    
    var postType = $('input[name=postType]:checked').val();
    sid = [0,7413129773084,7413136162844,7413143273500,0,7413143961628];
    cnt = [0,0,0,0,0,0]  
    var shipCost = 0;

    for (s in shipping_price){
      cnt[shipping_price[s]] = cnt[shipping_price[s]]+1;
    }

     $.post('/cart/update.js', {
         updates: {
            7413129773084: 0,
            7413136162844: 0,
            7413143273500: 0,
            7413143961628: 0
          }
        }                  
      );
    
  
   for (c in cnt){
     if (sid[c]>0){
      
      shipCost += (freight_charge_new[c]*cnt[c]);
      
      /*
        if (cnt[c]>0){
             $.ajax({
                type: "post",
                url: "/cart/update.js",
                data: [{"quantity": cnt[0], "id": sid[c]} ], 
                dataType: 'json',
                async: false,
                crossDomain: true                
            });
          };
     */
       
     };
    };
  
    if (shipCost > 0){    
      $('#checkoutButton').removeAttr("disabled");
      $('#ShippingTotal').html('+$'+shipCost+'.00 Postage & Handling via '+shipper+'<br><small>You order may take up to '+shippingDayStr+' to be dispatched.<br>Please contact us if your order is urgent.</small>');
    } else {
      $('#ShippingTotal').html('Free Delivery<br><small>You order may take up to '+shippingDayStr+' to be dispatched.');
    };

    if (encCorrect == true){
      $('#checkoutButton').removeAttr("disabled");
    };
    
};

$('input:radio[name="postType"]').change(function(){ 
	updatecart('clear');    
});

$('.s-qty__input').change(function(){
  	updatecart('clear');  
});

$('.s-qty__adjust').change(function(){
  	updatecart('clear');
});

updatecart('clear');

$('#CartSpecialInstructions').change(function(){
  if ( $('#CartSpecialInstructions').val().toLowerCase().indexOf('flat')!=-1 || $('#CartSpecialInstructions').val().toLowerCase().indexOf('fold')!=-1){
    $('#fold_warning').show();
  } else { 
  	$('#fold_warning').hide();
  }; });